import { useSyncExternalStore } from "react";
import { useMediaQuery } from "react-responsive";

const subscribe = () => () => {};

const useMedia = () => {
  const isClient = useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );

  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });
  const isTablet = !isMobile && !isDesktop;

  return { isMobile, isDesktop, isTablet, isClient };
};

export default useMedia;
